export default __webpack_public_path__ + "static/media/i (1).c487145a.jpg";